import I13nAnchor from './I13nAnchor';
import I13nLink from './I13nLink';

// we effectively want consumers to treat this as an I13nAnchor,
// where we do internal remapping of href => to if it's an internal link
type I13nLinkOrAnchorProps = React.ComponentProps<typeof I13nAnchor> & {
  // I13nLink requires href to always be string, not optional
  href: string;
  openInNewTab?: boolean;
};

const I13nLinkOrAnchor = (props: I13nLinkOrAnchorProps) => {
  const { href, openInNewTab = true, ...restProps } = props;

  const isExternal = href?.includes('https');

  if (isExternal) {
    return <I13nAnchor href={href} target={openInNewTab ? '_blank' : undefined} {...restProps} />;
  }

  return <I13nLink to={href} target="_self" {...props} />;
};

export default I13nLinkOrAnchor;
